var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSolana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.90007 14.0205H24.0801C24.3201 14.0205 24.5401 14.1205 24.7201 14.3005L27.7601 17.4205C28.3201 18.0005 27.9201 18.9805 27.1201 18.9805H7.94007C7.70007 18.9805 7.48007 18.8805 7.30007 18.7005L4.26007 15.5805C3.70007 15.0005 4.10007 14.0205 4.90007 14.0205ZM4.26007 9.88047L7.30007 6.76047C7.46007 6.58047 7.70007 6.48047 7.94007 6.48047H27.1001C27.9001 6.48047 28.3001 7.46047 27.7401 8.04047L24.7201 11.1605C24.5601 11.3405 24.3201 11.4405 24.0801 11.4405H4.90007C4.10007 11.4405 3.70007 10.4605 4.26007 9.88047ZM27.7401 23.1005L24.7001 26.2205C24.5201 26.4005 24.3001 26.5005 24.0601 26.5005H4.90007C4.10007 26.5005 3.70007 25.5205 4.26007 24.9405L7.30007 21.8205C7.46007 21.6405 7.70007 21.5405 7.94007 21.5405H27.1001C27.9001 21.5405 28.3001 22.5205 27.7401 23.1005Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSolana);
export default __webpack_public_path__ + "static/media/icon-solana.9fbcf79c67eaf07ab11b016b8ca878e9.svg";
export { ForwardRef as ReactComponent };